import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBookings,
  getBookingById,
  getBookingsByFilter,
} from "../../State/Booking/Action";
import moment from "moment";

import UpdateBookingDialog from "./UpdateBookingDialog";
import CreateWashDialog from "../Wash/CreateWashDialog";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancellationModal from "../Tools/CancellationModal";
import DoneIcon from "@mui/icons-material/Done";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Button, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import SearchBookingDialog from "../Search/SearchBookingDialog";
import AppPagination from "../Tools/AppPagination";
import { getWashTypeLabel } from "../../constants/washTypes";
import SearchWashDialog from "../Search/SearchWashDialog";

export default function AllBookings() {
  const dispatch = useDispatch();
  const { booking } = useSelector((store) => store);
  const [vehicle, setVehicle] = useState("CAR");
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("?vehicleType=CAR");
  useEffect(() => {
    let filter1 = `${filter}&page=${page}`;
    dispatch(getBookingsByFilter(filter1));
    console.log(filter1);
    console.log("All Bookings");
  }, [dispatch, page, filter]);

  const handleVehicleChange = (vehicle) => {
    setVehicle(vehicle);
    setFilter(`?vehicleType=${vehicle}`);
    setPage(0);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div>
        <div className="flex flex-row items-center justify-center gap-2 mt-2 mb-2">
          <Button
            variant={vehicle === "CAR" ? "contained" : "outlined"}
            color="primary"
            onClick={() => handleVehicleChange("CAR")}
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Car Wash
          </Button>
          <Button
            variant={vehicle === "BIKE" ? "contained" : "outlined"}
            color="primary"
            onClick={() => handleVehicleChange("BIKE")}
            sx={{ textTransform: "none", fontWeight: 600 }}
          >
            Bike Wash
          </Button>

          <SearchWashDialog setFilter={setFilter} />
        </div>

        <div className="sm:flex-auto">
          <h1 className="p-4 text-center font-extrabold text-2xl">
            All Bookings
          </h1>
        </div>
      </div>
      <div className="mx-auto sm:-mx-0 overflow-x-auto w-full ">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Booking Id
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Customer
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Contact No
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Address
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Booking Type
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-0"
              >
                Cancel?
              </th>

              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-bold text-gray-900"
              >
                Status
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Edit</span>
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Wash</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {booking.pagedBooking?.bookings?.map((booking) => (
              <tr
                key={booking.bookingId}
                class="border-2  border-blue-500 hover:border-blue-700 "
              >
                <td>
                  <span className="pl-4 font-bold text-sm  text-gray-900">
                    {booking.bookingNumber}
                  </span>
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {booking.customerName}
                </td>
                <td className="px-3 py-4 text-sm text-gray-500">
                  {booking.customerPhone}
                </td>
                <td className="px-3 py-4 trucate text-sm text-gray-500">
                  {booking.address}
                </td>
                <td className="w-full max-w-0 py-4 pr-3 text-sm font-medium pl-4 text-left sm:w-auto sm:max-w-none sm:pl-0">
                  {booking.vehicle} -{" "}
                  {getWashTypeLabel(booking.type)},{" "}
                  {booking.seater}
                  <dl className="font-normal ">
                    <dd className="mt-1 truncate text-gray-700">
                      Date: {moment(booking.scheduledAt).format("lll")}
                    </dd>

                    <dd className="mt-1 truncate text-gray-700 sm:hidden font-bold">
                      Estiamted Price: ₹{Math.round(booking.price)}
                    </dd>
                  </dl>
                </td>
                <td className="px-3 py-4 text-sm text-gray-500 text-center">
                  {(() => {
                    {
                      if (booking.status === "CANCELLED") {
                        return <DoneIcon sx={{ color: "#CD0300" }} />;
                      } else if (booking.washCreated) {
                        return <NotInterestedIcon sx={{ color: "#CD0300" }} />;
                      } else if (booking.status !== "CANCELLED") {
                        return (
                          <CancellationModal bookingId={booking.bookingId} />
                        );
                      }
                    }
                  })()}
                </td>

                <td className="px-3 py-4 text-sm text-gray-500">
                  {booking.status}
                </td>
                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  {booking.status !== "CANCELLED" && (
                    <UpdateBookingDialog
                      bookingId={booking.bookingId}
                      vehicle={booking.vehicle.toUpperCase()}
                      washType={booking.type}
                      bookingAt={booking.scheduledAt}
                      address={booking.address}
                    />
                  )}
                </td>

                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div>
                    {!booking.washCreated && booking.status !== "CANCELLED" && (
                      <CreateWashDialog
                        bookingId={booking.bookingId}
                        vehicle={booking.vehicle.toUpperCase()}
                        washType={booking.type}
                        bookingAt={booking.scheduledAt}
                        seater={booking.seater}
                      />
                    )}
                    {booking.washCreated && (
                      <div className="text-center">
                        <CheckCircleIcon color="success" />
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <AppPagination
          setPage={setPage}
          totalPages={booking.pagedBooking?.totalPages}
        />
      </div>
    </div>
  );
}
